import { Observable } from 'rxjs';
import { TermsUseResponse } from '../models/terms-use-response.model';

export abstract class TermsUseRepository {
    abstract getTermsUse(): Observable<TermsUseResponse>;
}
